import { VF_PARAGRAPH } from 'AppSrc/core/components/forms/form-base-components/v-f-paragraph';

const fieldId = 'paragraph-based-on';

const validator = () => null;

const vFParams = {
  paragraph: 'Based on the change completion, please complete the below Post Change Questionnaire for the CRQ.',
  fieldId,
};

const paragraphBasedOnTheEngineer = {
  id: fieldId,
  validator,
  vFParams,
  fieldType: VF_PARAGRAPH,
};

export { paragraphBasedOnTheEngineer };
